import { EntityListSkuInputData, EntityListSkuQuantityInputData } from '../entityListTypes';
import { BaseEntityListItemValidator } from './BaseEntityListItemValidator';
import { EntityListSkuItemValidator } from './EntityListSkuItemValidator';
import { ImportedItemValidatorContext } from '../../../../../lib/imports/importTypes';

/**
 * Checks if the pasted data contains the store, product and quantity.
 * Uses EntityListSkuItemValidator to check the product and store
 */
export class EntityListSkuQuantityItemValidator extends BaseEntityListItemValidator<EntityListSkuQuantityInputData> {
  private skuItemValidator = new EntityListSkuItemValidator();
  private allowZeroQuantity: boolean;

  constructor(allowZeroQuantity = false) {
    super();
    this.allowZeroQuantity = allowZeroQuantity;
  }

  validate(
    item: Partial<EntityListSkuInputData>,
    context?: ImportedItemValidatorContext[],
  ): string[] {
    const skuErrors: string[] = this.skuItemValidator.validate(item, context);
    const quantityErrors: string[] = this.checkQuantity(item);

    return skuErrors.concat(quantityErrors);
  }

  protected checkQuantity = (item: Partial<EntityListSkuQuantityInputData>): string[] => {
    const errors: string[] = [];

    if (!this.hasNonEmptyProperty(item, 'count')) {
      errors.push('Quantity cannot be empty');
    }

    if (item.count !== undefined) {
      if (item.count === 0 && !this.allowZeroQuantity) {
        errors.push('Quantity cannot be empty');
      }

      if (item.count < 0) {
        errors.push('Quantity cannot be negative');
      }
    }

    return errors;
  };
}
